import { isProduction } from '@upright/common/environment';
import { UserPrivate } from '@upright/common/iam/users/types';
import { useGetLoggedInUser, isOrWasTeam } from '../../hooks';

export const forceEnableGTM = process.env.FORCE_GTM === 'true';

export function useIsGoogleTagManagerEnabled() {
  const loggedInUser = useGetLoggedInUser();
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return isGoogleTagManagerEnabled(loggedInUser) || forceEnableGTM;
}

export function isGoogleTagManagerEnabled(loggedInUser: UserPrivate | undefined) {
  const enableGoogleTagManager = isProduction() && !isOrWasTeam(loggedInUser);
  return enableGoogleTagManager || forceEnableGTM;
}
